import { render, staticRenderFns } from "./MarksFixConfirm.vue?vue&type=template&id=0a66b1bc"
import script from "./MarksFixConfirm.vue?vue&type=script&lang=js"
export * from "./MarksFixConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports